module.exports = __webpack_public_path__ + "img/governance.502f6816.png";